export enum ExamStatus {
  PASSED = 'PASSED',
  FAILED = 'FAILED',
  AVAILABLE = 'AVAILABLE',
  NO_EXAMS = 'NO_EXAMS',
  LOCKED = 'LOCKED',
}
